module.exports = "/assets/site/images/icon-arrow-double-right.png?a30af03af029c2c702a35aa559963c0e";